import type { CSSProperties, FC, ReactNode } from 'react'

import { PHOTO } from '@/constants/media'

/** The approval mark on site, with the guarantee printed like a ticket stub. */
export const SentralHeroVisual: FC = (): ReactNode => (
    <div className='load-fade relative mx-auto w-full max-w-[38rem]' style={{ '--load-delay': '0.4s' } as CSSProperties}>
        <div className='relative aspect-square overflow-hidden bg-night-raised'>
            <img
                src={PHOTO.sentraltGodkjent}
                alt='Tømrer måler opp en planke på byggeplassen, med merket Sentralt godkjent'
                fetchPriority='high'
                decoding='async'
                className='size-full object-cover'
            />
        </div>

        <div className='sg-ticket absolute -right-3 top-[10%] w-[15rem] bg-paper text-night shadow-2xl md:-right-12 md:w-[17rem]'>
            <div className='p-4 md:p-5'>
                <p className='t-label text-slate'>Søknadsgaranti</p>
                <p className='mt-2 font-heading text-4xl font-bold leading-none tracking-tight md:text-5xl'>3</p>
                <p className='mt-1 text-sm font-semibold leading-snug'>søknader inkludert</p>
            </div>
            <div className='sg-perforation' aria-hidden='true' />
            <p className='p-4 text-xs leading-snug text-slate md:px-5'>
                Så langt er alle kundene våre godkjent på første forsøk.
            </p>
        </div>

        <p className='sg-clock absolute -bottom-6 left-4 flex items-baseline gap-3 bg-night px-4 py-3 text-paper shadow-2xl md:-left-10'>
            <span className='font-heading text-3xl font-light tracking-tight'>1</span>
            <span className='text-sm'>virkedag, som regel, fra første<br />samtale til innsendt søknad</span>
        </p>
    </div>
)
